var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-icon',_vm._g({attrs:{"color":"primary","large":""}},on),[_vm._v(_vm._s(_vm.$icons.help))])]}}])},[_c('div',{staticClass:"pos"},[_c('span',{staticClass:"width"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }